import {
  PAYMENTS_POST,
  PAYMENTS_XENDIT_POST,
  PAYMENTS_MIDTRANS_POST,
  PAYMENTS_DETAIL_GET,
  PAYMENTS_BANK_ACCOUNTS_GET,
  PAYMENTS_BANK_TRANSFER_POST,
  PAYMENTS_APPLY_VOUCHER_POST,
  PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST,
  PAYMENTS_MIDTRANS_DETAIL_GET,
  PAYMENTS_MIDTRANS_TOKENS_POST,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  PAYMENTS_KREDIVO_POST,
  PAYMENTS_AKULAKU_POST,
  PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST,
  PAYMENTS_ATOME_POST,
  GET_VOUCHER_CODE,
  PRODUCT_ADDON_FETCH
} from '../constants';
import error from '../utils/error';

const initialState = {
  payments: {
    isSubmit: false,
    error: null
  },
  paymentDetail: {
    isFetch: false,
    error: null
  },
  bankAccounts: {
    isFetch: false,
    error: null
  },
  paymentConfirmation: {
    isSubmit: false,
    error: null
  },
  voucher: {
    isSubmit: false,
    error: null
  },
  kredivoAvailableInstallment: {
    variant_id: null,
    isSubmit: false,
    error: null
  },
  akulakuAvailableInstallment: {
    data: [],
    variant_id: null,
    isSubmit: false,
    error: null
  },
  midtrans: {
    details: {
      data: null,
      isFetch: false,
      error: null
    },
    savedTokens: {
      data: null,
      isFetch: false,
      error: null
    }
  },
  voucherCode: {
    isFetch: true,
    error: null,
    code: ""
  },
  productAddon: {
    data:[],
    isFetch: false,
    status_code:null,
    error: null
  }
}

const applyPayments = (lastState, { payload }) => ({
  ...lastState,
  payments: { ...lastState.payments, ...payload, isSubmit: false, error: null }
})

const applyVoucher = (lastState, { payload }) => ({
  ...lastState,
  voucher: { ...lastState.voucher, ...payload, isSubmit: false, error: null }
})

const applyXenditPayment = (lastState, { payload }) => ({
  ...lastState,
  payments: { ...lastState.payments, ...payload, isSubmit: false, error: null }
})

const applyPaymentDetail = (lastState, { payload }) => ({
  ...lastState,
  paymentDetail: { ...lastState.paymentDetail, ...payload, isFetch: false, error: null }
})

const applyBankAccounts = (lastState, { payload }) => ({
  ...lastState,
  bankAccounts: { ...lastState.bankAccounts, ...payload, isFetch: false, error: null }
})

const applyKredivoInstallmentsType = (lastState, { payload }) => ({
  ...lastState,
  kredivoAvailableInstallment: { ...lastState.kredivoAvailableInstallment, ...payload, isSubmit: false, error: null }
})

const applyAkulakuInstallmentsType = (lastState, { payload }) => {
  const { data } = payload
  let list = data.installments.filter(item => item.skuId == payload.variant_id);
  if (list.length) list = [...list[0].items]
  return {
    ...lastState,
    akulakuAvailableInstallment: { ...lastState.akulakuAvailableInstallment, ...payload, data: list, isSubmit: false, error: null }
  }
}

const applyBankTransferConfirm = (lastState, { payload }) => ({
  ...lastState,
  paymentConfirmation: { ...lastState.paymentConfirmation, ...payload, isSubmit: false, error: null }
})

const voucherCodeData = (lastState, { payload }) => {
  const { data } = payload

  return {
    ...lastState,
    voucherCode: {
      ...lastState.voucherCode,
      isFetch: false,
      code: data.length > 0 ? data[0].value : "",
      error: null
    }
  }
}

const getProductAddon = (lastState, { payload }) => {
  const { data } = payload
  return {
    ...lastState,
    productAddon: { ...lastState.productAddon, isFetch: false, error: null, data:data.data, status_code:payload.status_code, message:payload.message  }
  }
}

const reducer = (state = initialState, action) =>
  action.type === `${PAYMENTS_APPLY_VOUCHER_POST}${PROMISE_PENDING}` ? { ...state, voucher: { ...state.voucher, isSubmit: true } } :
  action.type === `${PAYMENTS_APPLY_VOUCHER_POST}${PROMISE_FULFILLED}` ? applyVoucher(state, action) :
  action.type === `${PAYMENTS_APPLY_VOUCHER_POST}${PROMISE_REJECTED}` ? { ...state, voucher: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true, error: null } } :
  action.type === `${PAYMENTS_POST}${PROMISE_FULFILLED}` ? applyPayments(state, action) :
  action.type === `${PAYMENTS_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_XENDIT_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true } } :
  action.type === `${PAYMENTS_XENDIT_POST}${PROMISE_FULFILLED}` ? applyXenditPayment(state, action) :
  action.type === `${PAYMENTS_XENDIT_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_MIDTRANS_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true } } :
  action.type === `${PAYMENTS_MIDTRANS_POST}${PROMISE_FULFILLED}` ? applyXenditPayment(state, action) :
  action.type === `${PAYMENTS_MIDTRANS_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_KREDIVO_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true } } :
  action.type === `${PAYMENTS_KREDIVO_POST}${PROMISE_FULFILLED}` ? applyPayments(state, action) :
  action.type === `${PAYMENTS_KREDIVO_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_AKULAKU_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true } } :
  action.type === `${PAYMENTS_AKULAKU_POST}${PROMISE_FULFILLED}` ? applyPayments(state, action) :
  action.type === `${PAYMENTS_AKULAKU_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :
  
  action.type === `${PAYMENTS_ATOME_POST}${PROMISE_PENDING}` ? { ...state, payments: { ...state.payments, isSubmit: true } } :
  action.type === `${PAYMENTS_ATOME_POST}${PROMISE_FULFILLED}` ? applyPayments(state, action) :
  action.type === `${PAYMENTS_ATOME_POST}${PROMISE_REJECTED}` ? { ...state, payments: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_DETAIL_GET}${PROMISE_PENDING}` ? { ...state, paymentDetail: { ...state.paymentDetail, isFetch: true } } :
  action.type === `${PAYMENTS_DETAIL_GET}${PROMISE_FULFILLED}` ? applyPaymentDetail(state, action) :
  action.type === `${PAYMENTS_DETAIL_GET}${PROMISE_REJECTED}` ? { ...state, paymentDetail: { isFetch: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_BANK_ACCOUNTS_GET}${PROMISE_PENDING}` ? { ...state, bankAccounts: { ...state.bankAccounts, isFetch: true } } :
  action.type === `${PAYMENTS_BANK_ACCOUNTS_GET}${PROMISE_FULFILLED}` ? applyBankAccounts(state, action) :
  action.type === `${PAYMENTS_BANK_ACCOUNTS_GET}${PROMISE_REJECTED}` ? { ...state, bankAccounts: { isFetch: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_BANK_TRANSFER_POST}${PROMISE_PENDING}` ? { ...state, paymentConfirmation: { ...state.paymentConfirmation, isSubmit: true } } :
  action.type === `${PAYMENTS_BANK_TRANSFER_POST}${PROMISE_FULFILLED}` ? applyBankTransferConfirm(state, action) :
  action.type === `${PAYMENTS_BANK_TRANSFER_POST}${PROMISE_REJECTED}` ? { ...state, paymentConfirmation: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST}${PROMISE_PENDING}` ? { ...state, kredivoAvailableInstallment: { ...state.kredivoAvailableInstallment, isSubmit: true } } :
  action.type === `${PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST}${PROMISE_FULFILLED}` ? applyKredivoInstallmentsType(state, action) :
  action.type === `${PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST}${PROMISE_REJECTED}` ? { ...state, kredivoAvailableInstallment: { isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST}${PROMISE_PENDING}` ? { ...state, akulakuAvailableInstallment: { ...state.akulakuAvailableInstallment, isSubmit: true } } :
  action.type === `${PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST}${PROMISE_FULFILLED}` ? applyAkulakuInstallmentsType(state, action) :
  action.type === `${PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST}${PROMISE_REJECTED}` ? { ...state, akulakuAvailableInstallment: { ...state.akulakuAvailableInstallment, isSubmit: false, ...error(action.payload) } } :

  action.type === `${PAYMENTS_MIDTRANS_DETAIL_GET}${PROMISE_PENDING}` ? { ...state, midtrans: { ...state.midtrans, details: { ...state.midtrans.details, isFetch: true } } } :
  action.type === `${PAYMENTS_MIDTRANS_DETAIL_GET}${PROMISE_FULFILLED}` ? { ...state, midtrans: { ...state.midtrans, details: { ...state.midtrans.details, isFetch: false, error: null, ...action.payload } } } :
  action.type === `${PAYMENTS_MIDTRANS_DETAIL_GET}${PROMISE_REJECTED}` ? { ...state, midtrans: { ...state.midtrans, details: { ...state.midtrans.details, isFetch: false, ...error(action.payload) } } } :

  action.type === `${PAYMENTS_MIDTRANS_TOKENS_POST}${PROMISE_PENDING}` ? { ...state, midtrans: { ...state.midtrans, savedTokens: { ...state.midtrans.savedTokens, isSubmit: true } } } :
  action.type === `${PAYMENTS_MIDTRANS_TOKENS_POST}${PROMISE_FULFILLED}` ? { ...state, midtrans: { ...state.midtrans, savedTokens: { ...state.midtrans.savedTokens, isSubmit: false, error: null, ...action.payload } } } :
  action.type === `${PAYMENTS_MIDTRANS_TOKENS_POST}${PROMISE_REJECTED}` ? { ...state, midtrans: { ...state.midtrans, savedTokens: { ...state.midtrans.savedTokens, isSubmit: false, ...error(action.payload) } } } :

  action.type === `${GET_VOUCHER_CODE}${PROMISE_PENDING}` ? { ...state, voucherCode: { ...state.voucherCode, isFetch: true } } :
  action.type === `${GET_VOUCHER_CODE}${PROMISE_FULFILLED}` ? voucherCodeData(state, action) :
  action.type === `${GET_VOUCHER_CODE}${PROMISE_REJECTED}` ? { ...state, voucherCode: { ...state.voucherCode, isFetch: false, ...error(action.payload) } } :

  action.type === `${PRODUCT_ADDON_FETCH}${PROMISE_PENDING}` ? { ...state, productAddon: { ...state.productAddon, isFetch: true } } :
  action.type === `${PRODUCT_ADDON_FETCH}${PROMISE_FULFILLED}` ? getProductAddon(state, action) :
  action.type === `${PRODUCT_ADDON_FETCH}${PROMISE_REJECTED}` ? { ...state, productAddon: { ...state.productAddon, isFetch: false, status_code:action.payload.status_code, ...error(action.payload) } } :

  state


export default reducer